import styled, { css } from 'styled-components';
import { FloatActiveSpeakerButton, FloatActiveSpeakerWindow, FullscreenButton } from 'features/Room/components';
import { toggleHideWithTranslateAnimation } from 'ui/mixins';
import { RaiseHandIconWrapper } from 'features/RaiseHand/components/RaiseHandIcon/view';

export const StageLayout = styled.section<{ $isFooterHidden?: boolean }>`
    display: grid;
    grid-template-columns: 10fr 2fr;
    grid-template-rows: ${({ $isFooterHidden }) =>
        $isFooterHidden ? '100%' : 'calc(100% - var(--desktop-footer-height)) var(--desktop-footer-height)'};
    height: 100%;
`;

export const MainLayout = styled.aside<{
    $isWide?: boolean;
}>`
    box-sizing: border-box;
    position: relative;
    z-index: 1;
    transition: height 0.2s ease-in-out;
    padding: var(--desktop-padding);

    ${({ $isWide }) =>
        $isWide
            ? css`
                  grid-column: span 2;
              `
            : null}
`;

export const FullscreenStageLayout = styled.section<{ $isFooterHidden?: boolean }>`
    display: grid;
    grid-template-columns: 12fr;
    grid-template-rows: ${({ $isFooterHidden }) =>
        $isFooterHidden ? '100%' : 'calc(100% - var(--desktop-footer-height)) var(--desktop-footer-height)'};
    height: 100%;
    overflow-y: hidden;
`;

export const FullscreenMainLayout = styled.aside<{
    $isInterfaceHidden?: boolean;
}>`
    box-sizing: border-box;
    width: 100%;
    position: relative;
    z-index: 1;
    transition: height 0.2s ease-in-out;
    padding: var(--desktop-padding);
    grid-column: span 2;

    ${({ $isInterfaceHidden }) =>
        $isInterfaceHidden
            ? css`
                  height: 100vh; /* Fallback для браузеров, которые не поддерживают dvh */
                  height: 100dvh;
              `
            : null}
`;

export const RecordStageLayout = styled(StageLayout)`
    grid-template-rows: 100%;
`;

export const SidebarLayout = styled.aside<{ $hidden?: boolean }>`
    position: relative;
    z-index: 1;
    box-sizing: border-box;
    display: ${({ $hidden }) => ($hidden ? 'none' : 'block')};
    padding: var(--desktop-padding);
    padding-left: 0;
`;

export const FooterLayout = styled.nav<{ $hidden?: boolean }>`
    position: relative;
    z-index: 2;
    display: block;
    grid-column: span 2;
    height: var(--desktop-footer-height);
    background-color: rgb(19, 20, 25);
    ${({ $hidden }) => toggleHideWithTranslateAnimation($hidden)};
`;

export const ExitFullscreenButton = styled(FullscreenButton)`
    display: flex;
`;

export const FocusFloatActiveSpeakerButton = styled(FloatActiveSpeakerButton)`
    position: absolute;
    top: 28px;
    right: 28px;
    z-index: 2;
`;

export const FocusFloatActiveSpeakerWindow = styled(FloatActiveSpeakerWindow)`
    position: absolute;
    top: 20px;
    right: 20px;
    z-index: 2;

    ${RaiseHandIconWrapper} {
        right: 38px;
    }
`;
